import { Interceptor, Transport } from "@connectrpc/connect";
import { TransportProvider } from "@connectrpc/connect-query";
import { createConnectTransport } from "@connectrpc/connect-web";
import {
  QueryClient,
  QueryClientProvider as TanStackQueryClientProvider,
} from "@tanstack/react-query";
import { PropsWithChildren, useMemo } from "react";

import { firebaseAuth } from "../configs/firebase";

const authorizationInterceptor: Interceptor = (fn) => {
  return async (req) => {
    await firebaseAuth.authStateReady();
    const token = await firebaseAuth.currentUser?.getIdToken();
    if (token) {
      req.header.set("authorization", `Bearer ${token}`);
    }
    return fn(req);
  };
};

const getTransport = (): Transport => {
  return createConnectTransport({
    baseUrl: "/",
    interceptors: [authorizationInterceptor],
  });
};

const getClient = (): QueryClient => {
  return new QueryClient();
};

export const QueryClientProvider = ({ children }: PropsWithChildren) => {
  const transport = useMemo(() => getTransport(), []);
  const client = useMemo(() => getClient(), []);
  return (
    <TransportProvider transport={transport}>
      <TanStackQueryClientProvider client={client}>
        {children}
      </TanStackQueryClientProvider>
    </TransportProvider>
  );
};
